import { StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit, IPromise } from "angular";
import {
  IFieldArray,
  IFieldRuntimeObject,
  ITemplateScope,
} from "AngularFormly";
import { FormViewController } from "../../../../../app/records/forms/formView/controller";
import { set } from "lodash";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../app/records/server/serverUtility";

import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../app/records/forms/formView/service";
import fieldHelpers from "../../../../../app/ui-formly/fieldHelpers";

import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../app/records/forms/formly/fieldConfigurationHelpers";
import { Contract } from "../../../shared/models/contract";


export class GamingRelationshipEditComponentController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    FieldConfigurationHelperServiceName,
    serverUtilityName,
    "$state",
  ];
  model: any;
  formFields!: IFieldArray;
  RelationshipTypes: any[] = [];
  contractType!: string;
  contract: any;
  relationship: any;

  constructor(
    private readonly formViewService: FormViewService,
    private readonly fieldConfigurationHelperService: FieldConfigurationHelperService,
    public readonly serverUtility: ServerUtility,
    private readonly $state: StateService,
  ) {}  

  private initializeFormFields(relationship: any) {
    const that = this;
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          {
            key: "relationshipType",
            name: "relationshipType",
            type: "select",
            templateOptions: {
              label: "Gaming Relationship Type",
              options: [
                {
                  label: "ParentChild",
                  value: "ParentChild",
                }
              ],
              required: true,
              labelProp: "label",
              valueProp: "value",
            },
          },
          that.fieldConfigurationHelperService.selectAsyncField({
            key: "leftContractInstanceId",
            name: "leftContractInstanceId",
            label: "Contract Master Agreement",
            queryUrl: "/api/contract/contractMasterAgreement",
            getDefaultItem: function (model: any) {
              return {
                Id: model.ContractMasterAgreement?.ContractInstanceId,
                Name: model.ContractMasterAgreement?.Name,
              };
            },
            serverItemMapper: this.contractTypeQueryMapper,
            hideExpression: () => !relationship.ValidOnLeft,
          }),
          that.fieldConfigurationHelperService.selectAsyncField({
            key: "rightContractInstanceId",
            name: "rightContractInstanceId",
            label: "Contract",
            queryUrl: "/api/contract/contract",
            serverItemMapper: this.contractTypeQueryMapper,
            getDefaultItem: function (model: any) {
              return {
                Id: model.Contract?.ContractInstanceId,
                Name: model.Contract?.Name,
              };
            },
            hideExpression: () => !relationship.ValidForRight,
            
          }),
        ],
        4
      ),
    ];
  }
  $onInit(): void {
    this.contractType = this.contract.Type;

    if (this.contractType) {
        this.fetchRelationshipTypes(this.contractType, this.contract.ContractInstanceId )
        .then((relationship: any) => {
          this.relationship = relationship;
            this.initializeFormFields(this.relationship);
            this.setContractInstanceId();
            
        });
    }
  }

  submit(formViewController: FormViewController) {
    this.formViewService.submitForm({
      url: `/api/contract/gamingContractRelationship`,
      formObject: formViewController.model,
      formViewController,
      method: "post",
    })
    .then((result: any) => {  
      // Check if there are any errors in the response (status 400)
      if (result?.status === 400 && result.data?.ResponseStatus) {
        
      }
    })
    .catch((error: any) => {
      // Handle errors with API response
      const apiResponse = error?.data?.ResponseStatus;
      if (apiResponse) {
        formViewController.setApiErrors(apiResponse, '');
      }
    });
}


  private fetchRelationshipTypes(contractType: string, ContractInstanceId: any) {
    let url = `/api/contract/relationships/types?ContractType=${contractType}`;
    
    if(contractType === 'contract'){
       url = `/api/contract/relationships/types?ContractType=${contractType}&RightContractInstanceId=${ContractInstanceId}`;
    
    }
    
    return this.serverUtility.query({
        url: url,
        query: {
            Take: 10,
            OrderBy: "Id",
        },
    }).then((response: any) => {
        console.log(response);
        return response.RelationshipTypes[0];
    });
  }
  private setContractInstanceId(): void {
    if (this.relationship) {
      this.model = this.relationship.ValidOnLeft 
      ? { rightContractInstanceId: this.contract.ContractInstanceId } 
      : { leftContractInstanceId: this.contract.ContractInstanceId };
  
    }
  }

  private contractTypeQueryMapper(model: any){
    return {
      Id: model.ContractInstanceId,
      Name: model.Name
    }
  }

}
